import { FunctionComponent, useContext } from 'react'
import { CampaignContext } from '../src/state/CampaignContext'
import { SizeGuideModal } from './SizeGuideModal'

export const ProductMaterials: FunctionComponent = () => {
  const campaign = useContext(CampaignContext)
  const materials = campaign.offer.itemOffered.materials

  return (
    <div className="stack-l gap-s1">
      <ul className="list-style-none">
        {materials.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <div>
        <SizeGuideModal />
      </div>
    </div>
  )
}
